const route = {
    path: '/billing',
    meta: { authClass: 'protected' },
    children: [
        {
            path: '',
            components: {
                default: () => import(/* webpackChunkName: "billing" */ '../../components/views/billing/plans.vue'),
            },
        },
    ],
};

module.exports = route;
